import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0ccaac26"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex_zone" };
const _hoisted_2 = { class: "balance" };
import OrderNumber from '@/components/organisms/main/trade/order/OrderNumber.vue';
import { useStore } from '@/store/store';
import { watch } from 'vue';
import { decimalize } from '@/logics/utils';
export default /*#__PURE__*/ _defineComponent({
    props: {
        title: null,
        symbol: null,
        tradeType: { default: 'Limit' },
        step: null,
        mode: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const setBalance = () => {
            const item = store.state.balances.find((b) => b.symbol === props.symbol);
            const balance = item === null || item === void 0 ? void 0 : item.balance;
            const onHold = item === null || item === void 0 ? void 0 : item.onHold;
            if (!balance || onHold === null || onHold === undefined) {
                return '---';
            }
            const available = Number(balance) - Number(onHold);
            return decimalize(available, props.symbol, store.state.currencyInfo);
        };
        watch(() => store.state.balances, setBalance);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(OrderNumber, {
                    mode: props.mode,
                    title: props.title,
                    step: props.step,
                    currency: props.symbol
                }, null, 8, ["mode", "title", "step", "currency"]),
                _createElementVNode("div", _hoisted_2, _toDisplayString(setBalance()), 1)
            ]));
        };
    }
});
